import React from "react";
import ListItemReversedTextView from "../../../../../common/components/ListItemReversedTextView";
import {Word} from "../../../../../common/types/words";
import {useConjugation} from "../../../../inflections/hooks/useConjugation";
import {ConjugationView as InflectionsConjugationView} from "../../../../inflections/components/ConjugationView";

export interface ConjugationViewProps {
    word: Word
    language: string
}

export default function ConjugationView({word, language}: ConjugationViewProps) {

    const {hasConjugationInfo} = useConjugation({word, language});

    if (!word.morphology || !hasConjugationInfo) {
        return null;
    }

    return (
        <ListItemReversedTextView title={`Conjugation`} content={<InflectionsConjugationView word={word} language={language} /> } />
    );
}
